import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "documentation-guide"
    }}>{`Documentation guide`}</h1>
    <p>{`The source for this site is maintained in the `}<a parentName="p" {...{
        "href": "https://github.com/department-of-veterans-affairs/veteran-facing-services-tools/tree/master/packages/documentation"
      }}>{`documentation`}</a>{` package of the `}<a parentName="p" {...{
        "href": "https://github.com/department-of-veterans-affairs/veteran-facing-services-tools/"
      }}>{`veteran-facing-services-tools`}</a>{` repo.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      